import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { useTemplateSelector } from '../hooks/useTemplateSelector';

function TemplateSelector() {
    const { selectedTemplate, inputValue, setInputValue, templates, isLoading, handleTemplateChange } = useTemplateSelector();

    return (
        <Box pt={2}>
            <Autocomplete
                value={selectedTemplate}
                onChange={handleTemplateChange}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                options={templates}
                getOptionLabel={(option) => option.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={isLoading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Choose Logbook Template"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isLoading && <CircularProgress color="inherit" size={20} />}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                sx={{ mb: 2 }}
            />
        </Box>
    );
}

export default TemplateSelector;